'use client';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { REVIEW_QUERIES } from '@/infrastructure/review/utils/queries';
import type { GetProductReviewsRequest, ReviewStatisticsRequest } from '@/infrastructure/review/utils/types';

export const useReviewService = () => {
  const useGetProductReviews = (productId: number, params?: Omit<GetProductReviewsRequest, 'productId'>) => {
    return useQuery({
      ...REVIEW_QUERIES.getProductReviews(productId, params),
      enabled: Boolean(productId),
    });
  };

  const useGetCuratedReviews = () => {
    return useSuspenseQuery(REVIEW_QUERIES.getCuratedReviews());
  };

  const useGetReviewStatistics = (params: ReviewStatisticsRequest) => {
    return useQuery({
      ...REVIEW_QUERIES.getReviewStatistics(params),
      enabled: Boolean(params.productIds),
    });
  };

  return {
    useGetProductReviews,
    useGetCuratedReviews,
    useGetReviewStatistics,
  };
};
